import PropTypes from 'prop-types';

import { BaseURL } from '../../../../base/env';
import { TComma } from '../../../../base/utils';
import DetailModal from '../../ProductItem/DetailModal/DetailModal';
import ShareModal from '../../ProductItem/ShareModal/ShareModal';
import useProductItem from '../../ProductItem/useProductItem';
import styles from './Item.module.css';

const url = window.location.origin;
// const stock = 12;
const Item = ({ data, center = false }) => {
  const [
    shareModal,
    setShareModal,
    isModalVisible,
    HideModal,
    showModal_visible,
    add_to_cart,
    store,
    history
  ] = useProductItem();

  // const history = useHistory();

  return (
    <>
      <div
        className={`swiper-slide category-slider-item ${center ? styles.itemCenter : ''}`}
        onClick={() => {
          if (data?.use_details === true) {
            showModal_visible(true);
          } else {
            history.push(data?.product_link);
          }
        }}>
        <div className={styles.Center}>
          <img alt={data.name} src={BaseURL + data.image} />
        </div>
        <div className="w-100 center category-slider-item-title">
          <div>{data.name}</div>
        </div>
        <hr />
        <div className="center ma-t-5">
          <div>
            <strong className="slider-item-payable">{TComma(data.item_payable_amount)}</strong>
            <small>تومان</small>
          </div>
        </div>

        <div className="center ma-t-5">
          <div className="slide-real-price-container">
            {data.discount_amount ? (
              <>
                <del className="mar-l-5">{TComma(data.item_price)}</del>
                <span className="slide-off-percent">
                  {data.visible_discount_type === 'fixed'
                    ? TComma(data.item_fixed_discount_amount)
                    : `${data.discount_percentage} %`}
                </span>
              </>
            ) : null}
          </div>
        </div>
        <div className={styles.TextCounter}>
          {data.stock !== null ? `تنها ${data.stock} عدد در انبار باقی مانده` : ``}
        </div>
      </div>
      <ShareModal
        setShareModal={setShareModal}
        shareModal={shareModal}
        value={`${url}${history.location.pathname}#product-${data.id}`}
      />
      <DetailModal
        add_to_cart={add_to_cart}
        data={data}
        HideModal={() => {
          HideModal();
        }}
        isModalVisible={isModalVisible}
        setShareModal={setShareModal}
        showShare={false}
        store={store}
      />
    </>
  );
};

Item.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    use_details: PropTypes.bool,
    product_link: PropTypes.string,
    price: PropTypes.number,
    payable_amount: PropTypes.number,
    discount_amount: PropTypes.number,
    fixed_discount_amount: PropTypes.number,
    discount_percentage: PropTypes.number
  })
};

export default Item;
